<script lang="ts" setup>
import { useWindowSize } from '@vueuse/core'
import { DropdownItem, Icon, Tooltip } from '@brighterly/lib-lumee-ui'

import { NotificationPointer } from '@shared/ui/labels'
import { useSubscriptionStore } from '@entities/subscription'
import { useCustomerStore } from '@entities/customer'
import { useStaticRoutes } from '@shared/lib/routing'
import { AppRoute } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'
import { flushBeforeLeave } from '@shared/lib/amplitude'

defineOptions({
  name: 'LinkPaymentsSubscriptions',
})

const emit = defineEmits<{
  click: []
}>()

const text = 'Subscription'

const customerStore = useCustomerStore()
const subscriptionStore = useSubscriptionStore()

const route = useRoute()

const {
  isRoutePayments,
  isRoutePaymentsSubscriptions,
  isRoutePaymentsMethods,
  isRoutePaymentsHistory,
} = useStaticRoutes({ route })

const selected = computed(() => {
  return isRoutePayments.value
    || isRoutePaymentsSubscriptions.value
    || isRoutePaymentsMethods.value
    || isRoutePaymentsHistory.value
})

const tooltip = 'Subscriptions will be available after payment'

const {
  width,
} = useWindowSize()

const url = computed(() => {
  return (width.value >= 740)
    ? AppRoute.PaymentsSubscriptions
    : AppRoute.Payments
})

const handleClick = (): void => {
  if (selected.value) return

  trackEvent('Link_click', { feature: 'navigation', name: 'payments_subscriptions', text, url: url.value })
  emit('click')
  flushBeforeLeave()
  void navigateTo(url.value, { external: true })
}

</script>

<template>
  <div class="link-payments-subscriptions">
    <Tooltip
      :description="tooltip"
      size="sm"
      show-when="disabled"
    >
      <DropdownItem
        :title="text"
        role="menuitem"
        :aria-selected="undefined"
        :aria-current="selected ? 'page' : undefined"
        :selected="selected"
        :disabled="customerStore.isTypeDemo"
        @click="handleClick"
      >
        <template #leading>
          <Icon
            name="credit-card"
            size="md"
            :color="customerStore.isTypeDemo ? 'disabled' : 'default'"
          />
        </template>
        <template
          v-if="subscriptionStore.isBannerPaymentRetry"
          #trailingContent
        >
          <NotificationPointer
            view="default"
            color="red"
          />
        </template>
      </DropdownItem>
    </Tooltip>
  </div>
</template>
